import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const JobTypeFilter = ({ setJobType, value }) => {
  const options = [
    {
      label: 'Full Time',
      value: 'FULL_TIME',
    },
    {
      label: 'Part Time',
      value: 'PART_TIME',
    },
  ]
  const onChange = checkedValues => {
    setJobType(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default JobTypeFilter
